var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('medications-selection',{attrs:{"selected":_vm.personalInfo.selectedMedication,"medications":_vm.medicationsList},on:{"medicationupdatelist":_vm.updateMedicationList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }